























































  import { ChampFormulaire } from '@/commun/components/champ-formulaire';
  import { RadioGroupOuiNon } from '@/commun/components/champ-formulaire/radio-group-oui-non';
  import { Tooltip } from '@/commun/components/champ-formulaire/tooltip';
  import { StepperCredits } from '@/components/faculte/demandes/formulaires/champs/stepper-credits';
  import { SectionFormulaireCours } from '@/components/faculte/demandes/formulaires/creation-cours/section-formulaire-cours';
  import { SectionModeEnseignement } from '@/components/faculte/demandes/formulaires/creation-cours/section-information-mode-enseignement/sections-mode-enseignement';
  import ChargeTravail from '@/components/faculte/demandes/formulaires/creation-cours/section-information-mode-enseignement/sections-mode-enseignement/charge-travail/charge-travail.vue';
  import Vue from 'vue';

  export default Vue.extend({
    name: 'ModeEnseignementRegulierFormulaire',
    components: {
      ChargeTravail,
      ChampFormulaire,
      RadioGroupOuiNon,
      StepperCredits,
      Tooltip,
    },
    mixins: [SectionFormulaireCours, SectionModeEnseignement],
    props: {
      radioReinitialisable: {
        type: Boolean,
        default: true,
      },
    },
  });
